// New Search By Cherry

// מאזין גלובלי לכתיבה בשדות עם .search__input
document.addEventListener("input", async (e) => {
  if (!e.target.matches(".search__input")) return;

  const q = e.target.value.trim();
  if (!q) return;

  let targetSelectorName;
  if(e.target.getAttribute('data-print-in-selector')){
    targetSelectorName = e.target.getAttribute('data-print-in-selector');
  }else{
    targetSelectorName = "search-results";
  }
  
  const targetSelector =  document.querySelectorAll(`${targetSelectorName}`);
  
  var urlParams = new URLSearchParams(window.location.search);
  var rmvValue = urlParams.get('rmv');
  
  const url = `${window.location.origin}/search?options%5Bprefix%5D=last&rmv=`+rmvValue+`&q=${encodeURIComponent(q)}`;


  try {
    const res = await fetch(url, {
      method: "GET",
      headers: { "X-Requested-With": "XMLHttpRequest" }
    });
    const htmlText = await res.text();

    //console.log('%c '+htmlText,'background-color:green;');
    document.querySelectorAll(".search__form").forEach(item => {item.removeAttribute("loading")})

    // בניית DOM מה־HTML שהתקבל
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, "text/html");

    var site_vendor = "oral-b";
    if (document.getElementsByClassName("site_vendor_oral_b").length > 0) {
        site_vendor = "oral-b";
    } else if (document.getElementsByClassName("site_vendor_braun").length > 0) {
        site_vendor = "braun";
    } else  {
        site_vendor = rmvValue=="oral-b"?"braun":"oral-b";
    }

    // לוקחים את כל ה־product-card מתוך ה־card-grid
    const cards = Array.from(doc.querySelectorAll(".card-grid .product-card.item_card-" + site_vendor));

    // 1) אם רוצים "כל המידע" כמו שהוא – לוקחים outerHTML של כל כרטיס:
    const cardsHtmlList = cards.map(card => card.outerHTML);

    // דוגמה: לוג – כמה נמצאו והכרטיס הראשון
    //console.log("נמצאו כרטיסים:", cardsHtmlList.length);
    // if (cardsHtmlList[0]) console.log("כרטיס ראשון:", cardsHtmlList[0]);

    // 2) אופציונלי: להצגה מהירה כמו שהם (בלי לפרק שדות)


    // 3) אופציונלי: אם תרצה גם אובייקטים עם שדות בסיסיים (כותרת/לינק/תמונה/מחיר)
    // השארתי כאן פונקציה שתוכל להפעיל בעתיד:
    const structured = extractBasicFields(cards);
    let resPrint = ``;
    structured.forEach(element => {
      resPrint += `
        <a href="${element.href}" class="search-res-element">
          <img src="${element.img}">
          <span >${element.title}</span>
        </a>
      `
    });
    //console.log(structured);
    //console.log(targetSelector)
    targetSelector.forEach(e => {e.innerHTML = resPrint; e.style.display = "block"})

  } catch (err) {
    console.error("שגיאת fetch:", err);
    targetSelector.forEach(e => {e.innerHTML = resPrint; e.style.display = "block"})

  }
});

// פונקציה אופציונלית שחולצת שדות בסיסיים מכל product-card (אם תרצה שימוש בהמשך)
function extractBasicFields(cardElems) {
  return cardElems.map(card => {
    const titleEl =
      card.querySelector(".product-card__title a") ||
      card.querySelector("a.product-card__title") ||
      card.querySelector(".product-card__title");

    const linkEl =
      (titleEl && (titleEl.tagName === "A" ? titleEl : titleEl.closest("a"))) ||
      card.querySelector("a[href]");

    const imgEl = card.querySelector(".product-card__media img, .media img, img");
    const priceEl = card.querySelector(".price, .price__regular, [class*='price']");

    const title = titleEl ? (titleEl.textContent || "").trim() : "";
    const href = linkEl ? linkEl.getAttribute("href") : "";
    const img = imgEl ? (imgEl.getAttribute("src") || imgEl.getAttribute("data-src") || "") : "";
    const priceText = priceEl ? (priceEl.textContent || "").trim() : "";

    return { title, href, img, priceText, html: card.outerHTML };
  });
}